let injectables;
const metaApp = document.head.querySelector('meta[name="app"]');
const injectablesMissing =
  !metaApp ||
  ["<?php echo $injectables;?>", "{!!$injectables!!}"].includes(metaApp.content.replace(/ /g, ""))
    ? true
    : false;

if (injectablesMissing) {
  injectables = null;
} else {
  injectables = JSON.parse(metaApp.content);
}

export default injectables;
